import React from 'react';
import { FileDto, FileType, TeamPermission } from 'nekst-api';
import {
  BaseInputProps,
  useFormContextRequired,
  useInputHelper,
} from 'ui-builder';
import Layout from './Layout';
import { useAuthorizationChecker } from 'authorization-scope';

export interface FileUploaderInputProps extends BaseInputProps<number> {
  fileType: FileType,
  fileDataSource: string,
  asAdmin?: boolean,
}

export function FileUploaderInput(
  props: FileUploaderInputProps
) {
  const inputHelper = useInputHelper<number>(props);

  const formContext = useFormContextRequired();

  const file = formContext.data![props.fileDataSource] as FileDto | undefined;

  const { isGranted } = useAuthorizationChecker();

  return (
    <Layout
      {...inputHelper.getBaseInputLayoutProps()}
      fileType={props.fileType}
      fileDataSource={props.fileDataSource}
      file={file}
      asAdmin={props.asAdmin && isGranted(TeamPermission.MANAGE_PORTAL)}
    />
  );
}
